const ProductsSliderSkeleton = () => {
  return (
    <div className="flex flex-row gap-[22px]">
      <div className="flex-1">
        <div className="h-[215px] w-full bg-[#F7F7F5]"></div>
        <div className="mt-[10px] h-[30px] w-full bg-[#F7F7F5]"></div>
      </div>
      <div className="flex-1">
        <div className="h-[215px] w-full bg-[#F7F7F5]"></div>
        <div className="mt-[10px] h-[30px] w-full bg-[#F7F7F5]"></div>
      </div>
    </div>
  )
}

export default ProductsSliderSkeleton
